import { useState } from "react"
import LoginForm from "../components/LoginForm/LoginForm.component"
import { ILoginForm } from "../utils/interfaces/ILoginForm"
import { loginUser, resetPassword } from "../utils/services/user.service"
import { useDispatch } from "react-redux"
import { login } from "../utils/redux/userSlice"
import { useNavigate } from "react-router-dom"
import i18n from "../utils/languages/i18n"
import { LANGUAGES } from "aw-consts"


const LoginPage = () => {
    const [loginInfo, setLoginInfo] = useState<ILoginForm>({ email: '', password: '' })
    const [loading, setLoading] = useState(false)
    const [loadingRecovery,setLoadingRecovery] = useState(false)
    const [errorLogin, setErrorLogin] = useState(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onChangeLoginInfo = (e: any) => {
        setLoginInfo((prevValue) => ({ ...prevValue, [e.target.name]: e.target.value }))
    }

    const onDemoLogin = () => {
        setLoading(true)
        userLogin({ email:'', password:'' })
    }

    const userLogin = (credentials: ILoginForm) => {
        loginUser(credentials).then((json) => {
            setErrorLogin(false)
            const userInfo = {
                email: credentials.email,
                user: json.name,
                iduser: json.iduser,
                role: json.rol,
                token: json.token,
                auth: true,
                company: json.company
            }

            switch (json.language) {
                case LANGUAGES.Catalan:
                    i18n.changeLanguage("cat");
                    break;

                case LANGUAGES.Castellano:
                    i18n.changeLanguage("es");
                    break;

                case LANGUAGES.Ingles:
                    i18n.changeLanguage("eng");
                    break;

                default:
                    i18n.changeLanguage("es");
                    break;
            }

            dispatch(
                login(userInfo)
            );

            navigate('/')
            setLoading(false)

        }).catch(() => {
            setErrorLogin(true)
            setLoading(false)
        })
    }

    const onLogin = () => {
        setLoading(true)
        setErrorLogin(false)
        if (loginInfo.email.length > 0 && loginInfo.password.length > 0) {
            userLogin(loginInfo)
        }
        else {
            setLoading(false)
            setErrorLogin(true)
        }

    }

    const onRecovery = () => {
        setLoading(true)
        setErrorLogin(false)
        setLoadingRecovery(true)
        resetPassword(loginInfo.email).catch((e) => console.log('resetPasswordError', e))
        .finally(()=>{setTimeout(() => setLoadingRecovery(false), 60000); //1 min
        })        
    }

    return <LoginForm cancelRecoveryClick={()=>setLoading(false)} errorLogin={errorLogin} loading={loading} loadingRecovery={loadingRecovery} loginInfo={loginInfo} loginSubmit={onLogin} recoveryPwdSubmit={onRecovery} onChangeForm={onChangeLoginInfo} onDemoLogin={onDemoLogin} />
}

export default LoginPage